// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================== */
/*  Body & Layout           */
/* ======================== */
body {
    font-family: Arial, sans-serif;
    background-color: #f8f9fa;
    margin: 0;
    padding: 0;
  }
  
  .app-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
  
  .app-main {
    flex-grow: 1;
    padding: 20px;
  }
  
  /* ======================== */
  /*  Header & Nav            */
  /* ======================== */
  .app-header {
    background: linear-gradient(90deg, #007bff, #0056b3);
    color: white;
    padding: 10px 20px;
    position: relative;
    width: 100%;
  }
  
  .nav-brand {
    font-size: 24px;
    font-weight: bold;
  }
  
  /* Default Nav (Desktop) */
  .nav-links {
    list-style: none;
    margin: 0;
    display: flex;
    gap: 20px;
    align-items: center;
  }
  
  .nav-links li {
    display: inline-block;
  }
  
  .nav-links a {
    color: white;
    text-decoration: none;
    font-size: 16px;
    padding: 8px 16px;
    border-radius: 4px;
    transition: background-color 0.3s ease;
  }
  
  .nav-links a:hover {
    background-color: #003d79;
  }
  
  .logout-btn {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 8px 16px;
    font-size: 16px;
    cursor: pointer;
    border-radius: 4px;
  }
  
  .logout-btn:hover {
    background-color: #a71d2a;
  }
  
  /* ======================== */
  /*  Hamburger Icon          */
  /* ======================== */
  /* Hidden on larger screens by default */
  .menu-icon {
    display: none;
    flex-direction: column;
    cursor: pointer;
    z-index: 1001; /* make sure icon is above the menu */
  }
  
  .menu-icon span {
    background-color: #fff;
    height: 3px;
    width: 25px;
    margin: 4px 0;
    transition: 0.4s;
  }
  
  /* When .open is applied, transform the 3 lines into an "X" */
  .menu-icon.open span:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
  }
  .menu-icon.open span:nth-child(2) {
    opacity: 0;
  }
  .menu-icon.open span:nth-child(3) {
    transform: rotate(-45deg) translate(4px, -4px);
  }
  
  /* ======================== */
  /*  Mobile Menu Styles      */
  /* ======================== */
  @media (max-width: 768px) {
    /* Show the hamburger icon */
    .menu-icon {
      display: flex;
    }
  
    /* By default, hide the nav off-canvas (off to the left) */
    .nav-links {
      position: fixed;
      top: 0;
      left: -100%;  /* keep it off screen until "open" */
      width: 250px; /* increase width to prevent text cutoff */
      height: 100%;
      background-color: #007bff;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      padding-top: 60px; /* space for the menu icon/brand area */
      gap: 0;
      transition: left 0.3s ease-in-out;
      z-index: 1000;
    }
  
    /* Slide in from the left when .open */
    .nav-links.open {
      left: 0;
    }
  
    /* Each list item gets a bottom border to separate items */
    .nav-links li {
        margin-left: -40px;
      display: block;
      width: 100%;
      text-align: center;
      border-bottom: 1px solid #fff;
      padding: 10px 0;
    }
  
    /* Remove the border for the very last item */
    .nav-links li:last-child {
      border-bottom: none;
    }
  
    /* Make anchor text larger, remove extra border, and center the text */
    .nav-links a {
      display: block;
      width: 100%;
      font-size: 18px;
      padding: 10px 0;
      color: white;
      text-decoration: none;
      text-align: center; /* ensure text is centered */
      transition: background-color 0.3s ease;
    }
  
    /* Hover effect for mobile menu items */
    .nav-links a:hover {
      background-color: #003d79;
    }
  
    /* Adjust the logout button to match the mobile menu style */
    .logout-btn {
      display: block;
      width: 100%;
      background-color: #dc3545;
      color: white;
      border: none;
      padding: 12px 0;
      font-size: 18px;
      cursor: pointer;
      border-radius: 0;
      text-align: center;
      margin: 0;
    }
  }
  
  /* ======================== */
  /*  Footer                  */
  /* ======================== */
  .app-footer {
    background: linear-gradient(90deg, #007bff, #0056b3);
    color: white;
    text-align: center;
    padding: 15px 20px;
    position: sticky;
    bottom: 0;
    width: 100%;
  }
  
  .app-footer p {
    margin: 0;
  }
  
  .heart {
    color: red;
  }
  
  .table-container {
    margin-top: 20px;
    /* crucial part for horizontal scrolling */
    overflow-x: auto;  
    -webkit-overflow-scrolling: touch; /* smooth scrolling on iOS */
    background-color: #fff; 
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  /* Force table to have a minimum width, so a horizontal scroll triggers
     instead of columns squishing too tightly. Adjust as needed. */
  .table {
    width: 100%;
    border-collapse: collapse;
    min-width: 700px; /* pick a suitable min-width for your columns */
  }
  
  .table th, 
  .table td {
    padding: 12px;
    border-bottom: 1px solid #ddd;
    vertical-align: top;
    /* Optionally remove white-space: nowrap if you want text wrapping. */
  }
  `, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B,6BAA6B;AAC7B,6BAA6B;AAC7B;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B;IACE,oDAAoD;IACpD,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,0BAA0B;EAC1B;IACE,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,wCAAwC;EACxC;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,aAAa,EAAE,qCAAqC;EACtD;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;;EAEA,6DAA6D;EAC7D;IACE,4CAA4C;EAC9C;EACA;IACE,UAAU;EACZ;EACA;IACE,8CAA8C;EAChD;;EAEA,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B;IACE,4BAA4B;IAC5B;MACE,aAAa;IACf;;IAEA,0DAA0D;IAC1D;MACE,eAAe;MACf,MAAM;MACN,WAAW,GAAG,oCAAoC;MAClD,YAAY,EAAE,0CAA0C;MACxD,YAAY;MACZ,yBAAyB;MACzB,sBAAsB;MACtB,mBAAmB;MACnB,2BAA2B;MAC3B,iBAAiB,EAAE,uCAAuC;MAC1D,MAAM;MACN,iCAAiC;MACjC,aAAa;IACf;;IAEA,sCAAsC;IACtC;MACE,OAAO;IACT;;IAEA,0DAA0D;IAC1D;QACI,kBAAkB;MACpB,cAAc;MACd,WAAW;MACX,kBAAkB;MAClB,6BAA6B;MAC7B,eAAe;IACjB;;IAEA,6CAA6C;IAC7C;MACE,mBAAmB;IACrB;;IAEA,sEAAsE;IACtE;MACE,cAAc;MACd,WAAW;MACX,eAAe;MACf,eAAe;MACf,YAAY;MACZ,qBAAqB;MACrB,kBAAkB,EAAE,4BAA4B;MAChD,sCAAsC;IACxC;;IAEA,uCAAuC;IACvC;MACE,yBAAyB;IAC3B;;IAEA,4DAA4D;IAC5D;MACE,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,YAAY;MACZ,YAAY;MACZ,eAAe;MACf,eAAe;MACf,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,SAAS;IACX;EACF;;EAEA,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B;IACE,oDAAoD;IACpD,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,0CAA0C;IAC1C,gBAAgB;IAChB,iCAAiC,EAAE,4BAA4B;IAC/D,sBAAsB;IACtB,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA;kEACgE;EAChE;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB,EAAE,+CAA+C;EACnE;;EAEA;;IAEE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,qEAAqE;EACvE","sourcesContent":["/* ======================== */\n/*  Body & Layout           */\n/* ======================== */\nbody {\n    font-family: Arial, sans-serif;\n    background-color: #f8f9fa;\n    margin: 0;\n    padding: 0;\n  }\n  \n  .app-container {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n  }\n  \n  .app-main {\n    flex-grow: 1;\n    padding: 20px;\n  }\n  \n  /* ======================== */\n  /*  Header & Nav            */\n  /* ======================== */\n  .app-header {\n    background: linear-gradient(90deg, #007bff, #0056b3);\n    color: white;\n    padding: 10px 20px;\n    position: relative;\n    width: 100%;\n  }\n  \n  .nav-brand {\n    font-size: 24px;\n    font-weight: bold;\n  }\n  \n  /* Default Nav (Desktop) */\n  .nav-links {\n    list-style: none;\n    margin: 0;\n    display: flex;\n    gap: 20px;\n    align-items: center;\n  }\n  \n  .nav-links li {\n    display: inline-block;\n  }\n  \n  .nav-links a {\n    color: white;\n    text-decoration: none;\n    font-size: 16px;\n    padding: 8px 16px;\n    border-radius: 4px;\n    transition: background-color 0.3s ease;\n  }\n  \n  .nav-links a:hover {\n    background-color: #003d79;\n  }\n  \n  .logout-btn {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    padding: 8px 16px;\n    font-size: 16px;\n    cursor: pointer;\n    border-radius: 4px;\n  }\n  \n  .logout-btn:hover {\n    background-color: #a71d2a;\n  }\n  \n  /* ======================== */\n  /*  Hamburger Icon          */\n  /* ======================== */\n  /* Hidden on larger screens by default */\n  .menu-icon {\n    display: none;\n    flex-direction: column;\n    cursor: pointer;\n    z-index: 1001; /* make sure icon is above the menu */\n  }\n  \n  .menu-icon span {\n    background-color: #fff;\n    height: 3px;\n    width: 25px;\n    margin: 4px 0;\n    transition: 0.4s;\n  }\n  \n  /* When .open is applied, transform the 3 lines into an \"X\" */\n  .menu-icon.open span:nth-child(1) {\n    transform: rotate(45deg) translate(5px, 5px);\n  }\n  .menu-icon.open span:nth-child(2) {\n    opacity: 0;\n  }\n  .menu-icon.open span:nth-child(3) {\n    transform: rotate(-45deg) translate(4px, -4px);\n  }\n  \n  /* ======================== */\n  /*  Mobile Menu Styles      */\n  /* ======================== */\n  @media (max-width: 768px) {\n    /* Show the hamburger icon */\n    .menu-icon {\n      display: flex;\n    }\n  \n    /* By default, hide the nav off-canvas (off to the left) */\n    .nav-links {\n      position: fixed;\n      top: 0;\n      left: -100%;  /* keep it off screen until \"open\" */\n      width: 250px; /* increase width to prevent text cutoff */\n      height: 100%;\n      background-color: #007bff;\n      flex-direction: column;\n      align-items: center;\n      justify-content: flex-start;\n      padding-top: 60px; /* space for the menu icon/brand area */\n      gap: 0;\n      transition: left 0.3s ease-in-out;\n      z-index: 1000;\n    }\n  \n    /* Slide in from the left when .open */\n    .nav-links.open {\n      left: 0;\n    }\n  \n    /* Each list item gets a bottom border to separate items */\n    .nav-links li {\n        margin-left: -40px;\n      display: block;\n      width: 100%;\n      text-align: center;\n      border-bottom: 1px solid #fff;\n      padding: 10px 0;\n    }\n  \n    /* Remove the border for the very last item */\n    .nav-links li:last-child {\n      border-bottom: none;\n    }\n  \n    /* Make anchor text larger, remove extra border, and center the text */\n    .nav-links a {\n      display: block;\n      width: 100%;\n      font-size: 18px;\n      padding: 10px 0;\n      color: white;\n      text-decoration: none;\n      text-align: center; /* ensure text is centered */\n      transition: background-color 0.3s ease;\n    }\n  \n    /* Hover effect for mobile menu items */\n    .nav-links a:hover {\n      background-color: #003d79;\n    }\n  \n    /* Adjust the logout button to match the mobile menu style */\n    .logout-btn {\n      display: block;\n      width: 100%;\n      background-color: #dc3545;\n      color: white;\n      border: none;\n      padding: 12px 0;\n      font-size: 18px;\n      cursor: pointer;\n      border-radius: 0;\n      text-align: center;\n      margin: 0;\n    }\n  }\n  \n  /* ======================== */\n  /*  Footer                  */\n  /* ======================== */\n  .app-footer {\n    background: linear-gradient(90deg, #007bff, #0056b3);\n    color: white;\n    text-align: center;\n    padding: 15px 20px;\n    position: sticky;\n    bottom: 0;\n    width: 100%;\n  }\n  \n  .app-footer p {\n    margin: 0;\n  }\n  \n  .heart {\n    color: red;\n  }\n  \n  .table-container {\n    margin-top: 20px;\n    /* crucial part for horizontal scrolling */\n    overflow-x: auto;  \n    -webkit-overflow-scrolling: touch; /* smooth scrolling on iOS */\n    background-color: #fff; \n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  }\n  \n  /* Force table to have a minimum width, so a horizontal scroll triggers\n     instead of columns squishing too tightly. Adjust as needed. */\n  .table {\n    width: 100%;\n    border-collapse: collapse;\n    min-width: 700px; /* pick a suitable min-width for your columns */\n  }\n  \n  .table th, \n  .table td {\n    padding: 12px;\n    border-bottom: 1px solid #ddd;\n    vertical-align: top;\n    /* Optionally remove white-space: nowrap if you want text wrapping. */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
